/**
 * Shown while the active design's chunk downloads and while the session resolves.
 *
 * Deliberately variant-neutral and dependency-free: it renders before either design
 * system has loaded, so it cannot use their tokens. Kept dark to match both manifests'
 * background_color, which is what stops a white flash on an iOS home-screen launch.
 */
export function BootSplash() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: '#0B0D0F',
        color: '#8A94A6',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
        fontSize: 14,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
      }}
    >
      <span>Loading</span>
    </div>
  );
}
